<template>
  <div class="row mh-0">
    <form id="SIMULADOR" method="POST" :action="url" v-if="!allowSimulator">
      <div class="col-md-4 col-md-offset-4 mt-20">
        <div class="row">
          <div class="col-md-12 form-group">
            <input v-model="name" name="name" id="nome" type="text" class="form-control form-input" placeholder="Nome*"
                   required>
          </div>

          <div class="col-md-12 form-group person-types">
            <input type="radio"
                   class="mt-1"
                   :value="1"
                   v-model="type"
                   name="type"
                   id="legal_entity">
            <label for='legal_entity'>Pessoa jurídica</label>

            <input type="radio"
                   class="mt-1"
                   :value="0"
                   v-model="type"
                   name="type"
                   id="personal_entity">
            <label for='personal_entity'>Pessoa física</label>
          </div>

          <div v-show="type" class="col-md-12 form-group">
            <input v-model="cnpj" type="text" name="cnpj" id="cnpj" class="form-control form-input" placeholder="CNPJ*"
                   v-mask="cnpjMask">
            <div class="load-spin" style="display: none; position: absolute;top: 0.5em;right: 2em;">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>

            <has-error :errors="errorsData" field="cnpj"></has-error>

          </div>

          <div v-show="!type" class="col-md-12 form-group">
            <input v-model="cpf" type="text" name="cpf" id="cpf" class="form-control form-input" placeholder="CPF*"
                   v-mask="cpfMask">
            <div class="load-spin" style="display: none; position: absolute;top: 0.5em;right: 2em;">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>

            <has-error :errors="errorsData" field="cpf"></has-error>

          </div>

          <div v-show="!type" class="col-md-12 form-group">
            <input id="date_of_birth"
                   placeholder="00/00/0000"
                   name="date_of_birth" type="text"
                   class="form-control form-input">
            <div class="load-spin" style="display: none; position: absolute;top: 0.5em;right: 2em;">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>

            <has-error :errors="errorsData" field="cpf"></has-error>

          </div>

        </div>
        <br>
        <div class="row">

          <div class="col-md-12 form-group">
            <input v-model="email" type="email" name="email" id="email" class="form-control form-input"
                   placeholder="Email*" required>
          </div>

          <div class="col-md-12 form-group">
            <input v-model="phone" type="text" name="phone" id="telefone" class="form-control form-input"
                   v-mask="phoneMask"
                   placeholder="Telefone*" required>
          </div>

          <div class="col-md-12 form-group">
            <select :name="(!otherSegment) ? 'segment' : 'old-segment'" class="form-control form-input"
                    placeholder="Segmento de mercado*" id="segmento" required v-model="segment">
              <option v-for="(segment, index) in segments" :key="index" :value="segment">
                {{ segment }}
              </option>
            </select>

            <input
                    v-if="otherSegment"
                    name="segment"
                    id="segment"
                    type="text"
                    placeholder="Segmento de mercado*"
                    :value="manualSegment"
                    class="form-control form-input">
          </div>
        </div>
      </div>

      <input type="hidden" name="_token" :value="csrf">
      <input type="hidden" name="traffic_source" value="SIMULADOR">
      <input type="hidden" name="traffic_campaign" value="SIMULADOR">
      <input type="hidden" name="traffic_value" value="SIMULADOR">

      <div class="col-md-12 mt-70">
        <button
                @click.prevent="submitForm()"
                type="button"
                :disabled="!shouldShowSimulator"
                class="btn btn-submit col-md-2 col-md-offset-5">
          SIMULAR
        </button>

        <button class="hidden" type="submit" ref="submitForm" v-if="shouldShowSimulator">

        </button>
      </div>

      <div class="col-md-12 mt-20">
        <i class="simulator-icon fa fa-chevron-down"></i>
      </div>
    </form>

    <div class="mt-70 col-sm-12" :class="allowSimulator? '': 'disabled-event'">

      <div class="col-sm-4">
        <p class="step" data-step="1"><span>1º</span></p>
        <div class="step" id="step1">
          <h3>Escolha os formatos</h3>
          <p class="title-step">
            <small>Nos campos abaixo insira a quantidade de cartazes que pretende imprimir
            </small>
          </p>
          <form :class="allowSimulator? '': 'disabled'">
            <div class="form-group col-sm-6">
              <p><strong>placa A1</strong></p>
              <input placeholder="0" id="a1" name="a1" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">42x100cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>placa A2</strong></p>
              <input placeholder="0" id="a2" name="a2" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">42,3x70cm</small>
              </p>

            </div>
            <div class="form-group col-sm-6">
              <p><strong>placa A3S</strong></p>
              <input placeholder="0" id="a3s" name="a3s" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">30x70,3cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>A3</strong></p>
              <input placeholder="0" id="a3" name="a3" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">42x29,7cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>A4</strong></p>
              <input placeholder="0" id="a4" name="a4" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">21x29,7cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>A5</strong></p>
              <input placeholder="0" id="a5" name="a5" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">14,8x21cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>A6</strong></p>
              <input placeholder="0" id="a6" name="a6" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">10,5x14,8cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>A7</strong></p>
              <input placeholder="0" id="a7" name="a7" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">7,4x10,5cm</small>
              </p>
            </div>

            <div class="form-group col-sm-6">
              <p><strong>etiqueta P21</strong></p>
              <input placeholder="0" id="p21" name="p21" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">21x7cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>etiqueta P10</strong></p>
              <input placeholder="0" id="ep10" name="ep10" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">10x3,5cm</small>
              </p>
            </div>
            <div class="form-group col-sm-6">
              <p><strong>etiqueta P5</strong></p>
              <input placeholder="0" id="ep5" name="ep5" min="0" type="number" :readonly="!allowSimulator"
                     class="form-control paper-quantity">
              <p>
                <small class="size-paper">5x3,5cm</small>
              </p>
            </div>
          </form>

        </div>
      </div>
      <div :class="allowSimulator? '': 'disabled'">
        <div class="col-sm-4">
          <p class="step" data-step="2"><span>2º</span></p>
          <div class="step" id="step2">
            <h3>Escolha o tipo de papel</h3>
            <p class="title-step">
            </p>
            <div class="input-field col-sm-4 col-xs-4 pb ">
              <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 52.9 73.3"
                   style="max-width: 80px;">
                <path d="M52.9 52.9V0H0v73.3h32.5z" class="stP2"></path>
              </svg>
              <div class="am-radio radio-simulator">
                <input type="radio" value="white" name="paper" id="paper1" checked>
                <label for="paper1"><br>Papel microserrilhado Branco</label>
              </div>
            </div>
            <div class="input-field col-sm-4 col-xs-4 pb">
              <img src="/img/simulador/papel2.png"
                   class="img-responsive img-paper">
              <div class="am-radio radio-simulator">
                <input type="radio" value="yellow" name="paper" id="paper2">
                <label for="paper2"><br>Papel microserrilhado Amarelo</label>
              </div>
            </div>
            <div class="input-field col-sm-4 col-xs-4 pb ">
              <img src="/img/simulador/papel.png"
                   class="img-responsive img-paper">
              <div class="am-radio radio-simulator">
                <input type="radio" value="pre" name="paper" id="paper3">
                <label for="paper3"><br>Papel Pré Impresso</label>
              </div>
            </div>

          </div>
          <p class="step step3" data-step="3"><span>3º</span></p>
          <div class="step" id="step3">
            <h3>Impressão</h3>
            <p class="center-align title-step" style="margin-bottom: 17px">
              <small>Escolha a cor da impressão:
              </small>
            </p>
            <div class="input-field col-sm-4 col-xs-4 pb">
              <img src="/img/simulador/mono.png" alt=""
                   class="img-responsive paperImage white yellow">
              <img src="/img/simulador/pre-mono.png" alt=""
                   class="img-responsive paperImage pre" style="display: none;">
              <div class="am-radio radio-simulator">
                <input type="radio" value="pb" name="print" id="print1">
                <label for="print1">Impressão <br>em preto</label>
              </div>
            </div>
            <div class="input-field col-sm-4 col-xs-4 pb ">
              <img src="/img/simulador/verm-preto.png" alt=""
                   class="img-responsive paperImage white yellow">
              <img src="/img/simulador/pre-color.png" alt=""
                   class="img-responsive paperImage pre" style="display: none;">
              <div class="am-radio radio-simulator">
                <input type="radio" value="pv" name="print" id="print2">
                <label for="print2">Impressão <br>em preto e vermelho</label>
              </div>
            </div>
            <div class="input-field col-sm-4 col-xs-4 pb ">
              <img src="/img/simulador/fullcolor.png" alt="" class="img-responsive">
              <div class="am-radio radio-simulator">
                <input type="radio" value="full" name="print" id="print3">
                <label for="print3">Impressão <br>Full Collor</label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <p class="step" style="visibility: collapse" data-step="4"><span>4º</span>passo</p>

          <div class="step" id="step4">
            <h3>Melhor economia</h3>
            <div class="simulator-resume">
              <p class="title-step">
                <small>Veja como é possível economizar e inovar em sua produção de cartazes de ofertas.</small>
              </p>
            </div>
            <div class="row simulator-resume" style="display: flex; align-items: center">
              <div class="col-sm-6 col-xs-6">
                <p><b>LICENÇA</b></p>
              </div>
              <div class="col-sm-6 col-xs-6">
                <p class="float-right mb-0 tagsell-color">TAGSELL <strong class="version"></strong></p>
              </div>
            </div>

            <div class="row simulator-resume">
              <div class="col-sm-6 col-xs-6">
                <p><strong>QUANTIDADE DE OFERTAS</strong></p>
              </div>
              <div class="col-sm-6 col-xs-6 text-right">
                <p class="big total-offer">0</p>
              </div>
            </div>
            <div class="row simulator-resume">
              <div class="col-sm-7 col-xs-7 text-left">
                <div class="am-checkbox">
                  <div class="col-sm-12">
                    <input type="checkbox" name="paper-check" id="paper-check" checked>
                    <label for="paper-check">PAPEL <span id="paperLabel"
                                                         class="text-uppercase tagsell-color">Branco</span></label>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 col-xs-5 text-right papels img-box" style="padding-right: 30px;">
                <svg xmlns="http://www.w3.org/2000/svg" class="paperImage white"
                     viewBox="0 0 52.9 73.3">
                  <path d="M52.9 52.9V0H0v73.3h32.5z" class="stP0"></path>
                </svg>
                <img src="/img/simulador/papel2.png"
                     class="img-responsive img-paper paperImage yellow" style=" display: none;"/>
                <img src="/img/simulador/papel.png" style="display: none;"
                     class="img-responsive img-paper paperImage pre"/>
              </div>
            </div>

            <div class="row simulator-resume">
              <div class="col-sm-6 col-xs-6">
                <p><b>IMPRESSÃO</b> <strong>
                  <small id="printlabel" style="display: block; color: black;">
                  </small>
                </strong></p>
              </div>
              <div class="col-sm-6 col-xs-6 text-right img-box" style="padding-right: 30px">
                <img src="/img/simulador/mono.png"
                     class="img-responsive paper-step-4 paper-yellow paper-white pb">
                <img src="/img/simulador/verm-preto.png"
                     class="img-responsive paper-step-4 paper-white paper-yellow pv"
                     style=" display: none;">
                <img src="/img/simulador/fullcolor.png"
                     class="img-responsive paper-step-4 paper-white full"
                     style=" display: none;">
                <img src="/img/simulador/pre-mono.png"
                     class="img-responsive paper-step-4 paper-pre pb"
                     style=" display: none;">
                <img src="/img/simulador/pre-color.png"
                     class="img-responsive paper-step-4 paper-pre pv"
                     style=" display: none;">
              </div>
            </div>
            <div class="row simulator-resume">
              <div class="col-sm-7 text-left">
                <div class="am-checkbox">
                  <div class="col-md-12">
                    <input type="checkbox" name="press-check" id="press-check">
                    <label for="press-check">IMPRESSORA</label>
                    <label class="outsourcing">OUTSOURCING</label>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 tagsell-color" style="font-size: 13px">
                <span>LASER</span>
                <span id="printerType"> A4 MONO</span>
              </div>
            </div>
            <div class="row simulator-resume d-flex align-items-center justify-content-between">

              <p class="total-mes"><b>TOTAL / MÊS</b></p>

              <p class="big custo p-0">0 </p>

            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <br>
        <p class="container footer-simulator">
          <small><i>O simulador de investimento tem como objetivo apresentar
            variadas possibilidades para ajudar na tomada de decisão,
            desde o tipo da licença, o papel, o tipo de impressão desejada,
            até o modelo de impressora. Tudo isso está sujeito as variações
            econômicas e podem sofrer alterações sem aviso prévio.
            O custo da impressora considera as seguintes características:
            contrato de locação de 48 meses incluso: tonner, manutenção e peças.
            Conforme a combinação da grade de formatos o sistema indica qual
            modelo de impressora é o mais adequado, levando em conta os critérios
            produtividade e economia.<br> Para os itens do simulador - papel,
            impressora e suportes, usamos valores referencia FOB SP.
            Atendemos todo Brasil.
          </i>
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'simulator-form',

    props: {
      url: String,
      segments: Array,
      loggedInUser: Boolean,
    },

    mounted() {
      this.loadDocumentListeners();

      if (JSON.parse(window.localStorage.getItem('released_simulation'))) {
        const vm = this;
        setTimeout(function () {
          vm.throwGritter(
            'Sucesso',
            'Obrigado pelo cadastro, fique a vontade para simular seu investimento!',
            'success',
          );
        }, 500);

        window.localStorage.removeItem('released_simulation');
      }

      $('.disabled-event input').click((event) => {
        if (!this.allowSimulator) {
          event.preventDefault()
          this.throwGritter('Atenção!', 'Preencha seus dados para simular seu investimento', 'danger');
        }
      });
    },

    computed: {
      otherSegment() {
        return this.segment === 'Outros';
      },

      csrf() {
        return $('meta[name="csrf-token"]').attr('content');
      },

      shouldShowSimulator() {
        return this.isNotEmpty(this.name)
          && this.isValidCnpj()
          && this.isValidCpf()
          && this.isNotEmpty(this.phone)
          && this.isNotEmpty(this.email)
          && this.isValidEmail()
          && this.isNotEmpty(this.segment);
      },

      cnpjMask() {
        return '##.###.###/####-##';
      },

      cpfMask() {
        return '###.###.###-##';
      },

      phoneMask() {
        if (this.phone)
          if (this.phone.replace(/\D/g, '').length == 11) {

            return '(##) #####-#####';
          }

        return '(##) ####-####';
      },
    },

    data() {
      return {
        type: 1,
        errorsData: {
          cnpj: [],
          cpf: [],
        },
        cpf: undefined,
        cnpj: undefined,
        name: undefined,
        validCpf: false,
        phone: undefined,
        email: undefined,
        validCnpj: false,
        segment: this.segments[0],
        manualSegment: this.segment,
        allowSimulator: this.loggedInUser || JSON.parse(window.localStorage.getItem('released_simulation')),
      };
    },

    methods: {
      isNotEmpty(value) {
        return value != '' && value != undefined;
      },

      submitForm() {
        if (!this.allowSimulator) {
          if (!this.isValidEmail()) {
            this.throwGritter('Email', 'Preencha um email válido', 'danger');
            return false;
          }
          if (!this.isValidCnpj()) {
            this.throwGritter('Email', 'Preencha um cnpj válido', 'danger');
            return false;
          }
          if (!this.isValidCpf()) {
            this.throwGritter('Email', 'Preencha um cpf válido', 'danger');
            return false;
          }

          window.localStorage.setItem('released_simulation', 'true');

          axios.post('/loja/sendRdStationCrm', {
            name: this.name,
            email: this.email,
            cnpj: this.cnpj,
            cpf: this.cpf,
            phone: this.phone,
            segment: this.segment,
          }).then((response) => response.data);

          const vm = this;
          setTimeout(function () {
            $(vm.$refs.submitForm).click();
          }, 500);
        }
      },

      isValidEmail() {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return regex.test(this.email);
      },

      throwGritter(title, text, className) {
        $.gritter.add({
          title: title,
          text: text,
          time: 3000,
          class_name: `color ${className}`,
        });
      },

      isValidCnpj() {

        if (!this.type)
          return true;

        let cnpj = (this.cnpj) ? this.cnpj.replace(/[^\d]+/g, '') : '';

        if (cnpj == '' || cnpj.length != 14) return false;

        const invalidCnpjs = [
          "00000000000000",
          "11111111111111",
          "22222222222222",
          "33333333333333",
          "44444444444444",
          "55555555555555",
          "66666666666666",
          "77777777777777",
          "88888888888888",
          "99999999999999",
        ];

        if (invalidCnpjs.includes(cnpj))
          return false;

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
          return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
          return false;

        return this.validCnpj;

      },

      isValidCpf() {
        if (this.type)
          return true;

        let cpf = (this.cpf) ? this.cpf.replace(/\D/g, '') : '';

        if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
        let result = true;
        [9, 10].forEach(function (j) {
          let soma = 0, r;
          cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
            soma += parseInt(e) * ((j + 2) - (i + 1));
          });
          r = soma % 11;
          r = (r < 2) ? 0 : 11 - r;
          if (r != cpf.substring(j, j + 1)) result = false;
        });
        return result && this.validCpf;
      },

      loadDocumentListeners() {
        const vm = this;
        $('[name=cnpj]').on('keyup', _.debounce(function () {
          const cnpj = $('[name=cnpj]').val().replace(/[/.-]/g, '');
          if (cnpj.length === 14) {
            $('.load-spin').show(200);
            $.get('/ajax/cnpj/' + cnpj).then(response => {
              $('.load-spin').hide(200);
              $('.load-spin').hide(200);
              vm.errorsData.cnpj = '';
              vm.validCnpj = true;
              return;
            }).catch(error => {
              $('.load-spin').hide(200);
              vm.throwGritter('CNPJ', error.responseJSON.message, 'danger');
              vm.errorsData.cnpj = [error.responseJSON.message];
              vm.validCnpj = false;
            });

          }
        }, 500));

        $('[name=date_of_birth], [name=cpf]').on('keyup', _.debounce(function () {
          const dateOfBirth = $('[name=date_of_birth]').val().replace(/[/]/g, '-');
          const cpf = $('[name=cpf]').val().replace(/[.-]/g, '');
          if (dateOfBirth.length === 10 && cpf.length === 11) {
            $('.load-spin').show(200);
            $.get('/ajax/validate-cpf/' + cpf + '/' + dateOfBirth).then(response => {
              $('.load-spin').hide(200);
              vm.errorsData.cpf = '';
              vm.validCpf = true;
              return;
              $('.load-spin').hide(200);
            }).catch(error => {
              vm.validCpf = false;
              $('.load-spin').hide(200);
              vm.throwGritter('CPF', error.responseJSON.message, 'danger');
              vm.errorsData.cpf = [error.responseJSON.message];
            });
          }
        }, 500));
      },
    },
  };
</script>

<style scoped>
  .paper-quantity {
    background-color: white;
  }

  .form-input:hover {
    border: 1px solid #354558;
  }

  .form-input:focus {
    border: 1px solid #354558;
  }

  .register-title {
    color: #354558;
    padding-left: 20px;
  }

  .btn-submit {
    border-radius: 0;
    background: #354558 !important;
    color: #ffffff;
    font-weight: bold;
  }

  .simulator-icon {
    font-size: 30px;
    color: #354558;
  }

  .radio-simulator > label {
    line-height: 17px;
  }

  .img-box > img {
    max-width: 50px;
  }

  .img-box > svg {
    max-width: 50px;
  }

  .size-paper {
    text-transform: none;
  }

  .disabled input {
    background-color: #eee;
  }

  .disabled .am-checkbox input[type=checkbox]:checked + label:before,
  .disabled .am-checkbox input[type=radio]:checked + label:before,
  .disabled .am-radio input[type=checkbox]:checked + label:before,
  .disabled .am-radio input[type=radio]:checked + label:before {
    color: rgba(53, 69, 88, 0.58);
    border-color: rgba(53, 69, 88, 0.58);
  }

  .footer-simulator {
    text-align: left;
    text-transform: none;
    max-width: 100%;
  }

  .tagsell-color {
    color: #354558 !important;
  }

  .img-paper {
    border: none !important;
  }

  .outsourcing {
    margin-left: 28px !important;
    font-size: 11px !important;
  }

  @media (max-width: 1100px) {
    .simulator-resume {
      font-size: 10px;
    }

    .outsourcing {
      margin-left: 0 !important;
    }
  }

  @media (max-width: 360px) {
    .simulator-resume {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    .outsourcing {
      margin-left: 28px !important;
    }
  }

  .person-types label {
    color: #555;
  }

  .person-types {
    padding-top: 5px;
  }

  .d-flex {
    display: flex;
  }

  .align-items-center {
    align-items: center;
  }

  .justify-content-between {
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/Simulator.vue